/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { DonationInfoResponse, DonationState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<DonationState, RootState> = {
  info(state): DonationInfoResponse {
    return state.info.data;
  },
};
